import { createAction } from '@poa/state';


export const fetchPayer = createAction('fetchPayer', id => ({ id }));
export const fetchPayerSuccess = createAction('fetchPayerSuccess', data => ({ data }));
export const fetchPayerFailed = createAction('fetchPayerFailed', () => ({}));


export const fetchPayers = createAction(
  'fetchPayers',
  (
    filter_by = null,
    page = 1,
    search = null,
    page_size = 15,
  ) => ({ filter_by, page, search, page_size })
);

export const refreshPayers = createAction(
  'refreshPayers',
  (
    filter_by = null,
    page = 1,
    search = null,
    page_size = 15,
    ) => ({ filter_by, page, search, page_size })
    );
    

export const fetchPayersSuccess = createAction('fetchPayersSuccess', data => ({ data }));
export const fetchPayersFailed = createAction('fetchPayersFailed', () => ({}));
  
// ui
export const toggleFavorite = createAction('toggleFavorite', id => ({ id }));

export const setDates = createAction('setDates', ({ startDate, endDate }) => ({
  startDate,
  endDate
}));

export const changeFiltering = createAction('changeFiltering', filtering => ({
  filtering
}));
export const resetFilteringOptions = createAction('resetFilteringOptions', filtering => ({
  filtering
}));

// presets
export const saveColumnPreset = createAction(
  'saveColumnPreset',
  (preset, availablePresets) => ({
    preset,
    availablePresets
  })
);
export const deletePreset = createAction('deletePreset', id => ({ id }));
export const changeColumnPreset = createAction('changeColumnPreset', presetId => ({
  presetId
}));
export const changeColumnVisibility = createAction('changeColumnVisibility', column => ({
  column
}));
export const toggleAllColumns = createAction('toggleAllColumns', () => ({}));

export const resetColumnSettings = createAction(
  'resetColumnSettings',
  ({ availablePresets, presetId }) => ({
    availablePresets,
    presetId
  })
);

export const changePresetOrder = createAction('changePresetOrder', columns => ({ columns }));
export const changeRounding = createAction('changeRounding', isDecimal => ({ isDecimal }));
export const changeSearch = createAction('changeSearch', searchClause => ({ searchClause }));
